import { memo } from 'react';

import { FiBell } from 'react-icons/fi';

import { useBroadcastQuery } from '@hooks';

import * as S from './styles';

const CallToAction = () => {
  const { data } = useBroadcastQuery();

  if (!data?.settings.data.call_action) {
    return null;
  }

  const { message, url_action, cta, color } = data.callAction.data;

  return (
    <S.Container $color={color}>
      <S.IconWrapper $color={color}>
        <FiBell />
      </S.IconWrapper>
      <S.Text>{message}</S.Text>
      {cta && (
        <S.Button
          {...(url_action
            ? { href: url_action, target: '_blank', rel: 'noopener noreferrer' }
            : {})}
          as={url_action ? 'a' : 'button'}
          $color={color}
        >
          {cta}
        </S.Button>
      )}
    </S.Container>
  );
};

export default memo(CallToAction);
